import { AppUtil } from 'kuaidong-lib'
import {
  IHomeworkNextPublishStatus,
  IHomeworkUpdateTimeForm,
  INewHomeworkClassListHomeworkDetail,
  INewHomeworkClassListItem,
  INewHomeworkClassListLongTermHomeworkDetail,
  INewHomeworkClazzPagination,
} from 'kuaidong-model/src/homework-new'

export class AHomeworkNew {
  public static teacherHomeworkList(
    class_ids: number[] | null,
    params?: { typ?: number }
  ): Promise<INewHomeworkClassListItem[]> {
    return AppUtil.httpPOST('/homework_schedule/class_list', {
      class_ids,
      ...(params || {}),
    })
  }
  public static classHomeworkList(
    class_id: number,
    need_content: boolean,
    limit?: number,
    offset?: number
  ): Promise<INewHomeworkClazzPagination> {
    return AppUtil.httpGET('/homework_schedule/homework_list', {
      class_id,
      need_content,
      limit,
      offset,
    })
  }

  public static homeworkDetail(
    schedule_id: string
  ): Promise<INewHomeworkClassListHomeworkDetail | INewHomeworkClassListLongTermHomeworkDetail> {
    return AppUtil.httpGET('/homework_schedule/detail', {
      schedule_id,
    })
  }

  public static homeworkScheduleDelete(schedule_id: string, cascade = false) {
    return AppUtil.httpPOST(`/homework_schedule/delete?schedule_id=${schedule_id}&cascade=${cascade}`)
  }

  public static homeworkScheduleUpdateTime(form: IHomeworkUpdateTimeForm) {
    return AppUtil.httpPOST('/homework_schedule/update_time', form)
  }

  public static homeworkNextPublishStatus(
    class_id: number,
    exclude_schedule_id: string,
    start_time?: string,
    end_time?: string
  ): Promise<IHomeworkNextPublishStatus> {
    return AppUtil.httpGET('/homework_schedule/get_next_publish', {
      class_id,
      exclude_schedule_id,
      start_time,
      end_time,
    })
  }

  public static homeworkCascadeCount(schedule_id: string): Promise<number> {
    return AppUtil.httpGET('/homework_schedule/cascade_count', {
      schedule_id,
    })
  }
}
